/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminUsersOtgsSelector
 */
export interface OutputAdminUsersOtgsSelector {
    /**
     * 
     * @type {number}
     * @memberof OutputAdminUsersOtgsSelector
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminUsersOtgsSelector
     */
    name: string;
}

/**
 * Check if a given object implements the OutputAdminUsersOtgsSelector interface.
 */
export function instanceOfOutputAdminUsersOtgsSelector(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAdminUsersOtgsSelectorFromJSON(json: any): OutputAdminUsersOtgsSelector {
    return OutputAdminUsersOtgsSelectorFromJSONTyped(json, false);
}

export function OutputAdminUsersOtgsSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminUsersOtgsSelector {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputAdminUsersOtgsSelectorToJSON(value?: OutputAdminUsersOtgsSelector | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

